export default __webpack_public_path__ + "static/media/image_full_25.d9d46ce4.svg";